export default __webpack_public_path__ + "static/html-f08f7501a638838b0664563fb1d1375d.png";